/**
 * Rebuy cart: make the page behind it inert while it is open.
 *
 * The Rebuy cart (#rebuy-cart, a body child) traps Tab itself and sets aria-modal,
 * but leaves the page reachable by a screen reader (audit 1.4.1). Workaround for
 * vendor markup: it relies on the `is-visible` class Rebuy puts on #rebuy-cart and
 * may need updating if the app changes. Remove it once Rebuy fixes the cart itself.
 */
(() => {
  const CART_ID = 'rebuy-cart';
  const SKIP_TAGS = new Set(['SCRIPT', 'STYLE', 'LINK', 'NOSCRIPT', 'TEMPLATE']);
  // Live regions and the consent banner stay reachable
  const KEEP_SELECTOR = '[aria-live], [role="status"], [role="alert"], #CybotCookiebotDialog';
  const inerted = new Set(); // only elements we set `inert` on
  let watchedCart = null;

  function sync() {
    inerted.forEach((element) => element.removeAttribute('inert'));
    inerted.clear();
    const cart = document.getElementById(CART_ID);
    if (!cart?.classList.contains('is-visible')) return;

    Array.from(document.body.children).forEach((element) => {
      if (element === cart || SKIP_TAGS.has(element.tagName) || element.hasAttribute('inert')) return;
      if (element.matches(KEEP_SELECTOR)) return;
      element.setAttribute('inert', '');
      inerted.add(element);
    });
  }

  function watch() {
    const cart = document.getElementById(CART_ID);
    if (!cart || cart === watchedCart) return;
    watchedCart = cart;
    new MutationObserver(sync).observe(cart, { attributes: true, attributeFilter: ['class'] });
    sync();
  }

  // The cart is added to <body> by the app after load
  new MutationObserver(watch).observe(document.body, { childList: true });
  watch();
})();
